import { postRoute } from "../client"

export const claimCaseRoute = postRoute<{ success: true; caseId: string }>("/api/engagement/cases/claim")
